const monitor = async ({ next, router, to, store }) => {
  let alunos = store.state.monitorAlunos.listAlunos;
  let alunosExcluir = alunos;
  let dataAtual = new Date();

  if (alunos && alunos.length > 0) {
    for (const index in alunos) {
      if (alunos[index].timer && alunos[index].timer.dateTimeLimit != null && new Date(alunos[index].timer.dateTimeLimit) < dataAtual && alunos[index].situacao != "Finalizada") {
        alunos[index].situacao = 'Finalizada';   
        await store.dispatch("monitorAlunos/setListAlunos", alunos[index]);
      }
  
      if ((alunos[index].dataFimProva) && alunos[index].dataFimProva != null || alunos[index].dataFimProva != undefined) {
        let data = new Date(alunos[index].dataFimProva);
        if (data < dataAtual) {
          alunosExcluir.splice(index, 1);
        }
      }
    }

    if (alunosExcluir.length < alunos.length) await store.dispatch("monitorAlunos/unsetListAlunos", alunosExcluir);
  }

  return next();
};

export default monitor;


// WEBPACK FOOTER //
// ./src/middleware/monitor.js